export default __webpack_public_path__ + "static/media/s1_female.ebcd4185.wav";